export enum COLLECTION_TYPE {
  CURATED = 'curated',
  BROWSE = 'browse',
  TAILORED_LEARNING = 'tailored-learning',
}
